import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  iconUploadContainer: {
    height: '100%',
    alignItems: 'center',
  },
  multiselectTitle: {
    marginBottom: '4px',
  },
  iconUploadPreviewContainer: {
    marginTop: '10px',
  },
  iconPreview: {
    maxWidth: 200,
    maxHeight: '100%',
  },
  imageContainer: {
    display: 'flex',
    paddingLeft: 10,
  },
})

export { useStyles }
